// Single source for the backend API base URL.
//
// Set at build time via REACT_APP_BACKEND_URL (Cloudflare Pages env). Falls back
// to the prod backend so a missing/mis-set env var never produces
// `undefined/api/...` requests — previously ~24 files read process.env directly
// with NO fallback while one (useFeatureFlag) had the fallback, an inconsistency
// that centralising here removes. Never re-read process.env.REACT_APP_BACKEND_URL
// or re-hardcode the onrender URL elsewhere; import API_URL from here.
export const API_URL =
  process.env.REACT_APP_BACKEND_URL || "https://strongerbot-api.onrender.com";

// How long (ms) a first authed request may hang before we reassure the user
// that the backend is cold-starting (Render Free spins down after 15min idle,
// so the first request can take 30-50s). Single source so the register + login
// "server waking up" hints fire at the same threshold; a warm backend answers
// in <1s and never reaches it. Bump this if we move off Render Free.
export const COLD_START_HINT_MS = 7000;
